var React = require('react');

function StarItem (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 0L23.0615 12.609L34.1421 5.85786L27.391 16.9385L40 20L27.391 23.0615L34.1421 34.1421L23.0615 27.391L20 40L16.9385 27.391L5.85786 34.1421L12.609 23.0615L0 20L12.609 16.9385L5.85786 5.85786L16.9385 12.609L20 0Z","fill":"#303030"}));
}

StarItem.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = StarItem;

StarItem.default = StarItem;
